import { MaskedLines } from "./Reveal";

// Consistent dark hero band for inner pages
export const PageHeader = ({ overline, titleLines = [], description, children }) => (
  <section className="relative overflow-hidden bg-navy pb-16 pt-32 md:pb-24 md:pt-40">
    <div
      className="pointer-events-none absolute inset-0 opacity-40"
      style={{
        background:
          "radial-gradient(50% 60% at 15% 0%, hsla(224,76%,48%,0.35), transparent), radial-gradient(40% 50% at 95% 20%, hsla(21,100%,50%,0.18), transparent)",
      }}
    />
    <div className="container-asai relative z-10">
      {overline && (
        <span className="mb-5 block text-xs font-semibold uppercase tracking-[0.22em] text-orange">
          {overline}
        </span>
      )}
      <h1 className="font-heading text-5xl font-bold leading-[0.95] tracking-tight text-white md:text-7xl">
        <MaskedLines lines={titleLines} />
      </h1>
      {description && (
        <p className="mt-6 max-w-2xl text-lg text-white/70 md:text-xl">{description}</p>
      )}
      {children && <div className="mt-8">{children}</div>}
    </div>
  </section>
);
